var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-results"},[_c('button',{staticClass:"btn btn-link px-2",attrs:{"id":"downloadResultsBttn","disabled":_vm.numResults < 1},on:{"click":function($event){$event.stopPropagation();return _vm.downloadResults.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-download",attrs:{"aria-hidden":"true"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }